import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1242.35294,451.753412 L1242.35294,1468.224 L757.496471,1468.224 L338.823529,1886.89694 L338.823529,1468.224 L0,1468.224 L0,451.753412 L1242.35294,451.753412 Z M1920.03388,0.0338823529 L1920.03388,1016.50447 L1694.15153,1016.50447 L1694.15153,1435.51624 L1355.21506,1096.57976 L1355.21506,338.857412 L677.680941,338.857412 L677.680941,0.0338823529 L1920.03388,0.0338823529 Z M677.76,1016.45929 L338.823529,1016.45929 L338.823529,1129.40047 L677.76,1129.40047 L677.76,1016.45929 Z M903.529412,790.576941 L338.823529,790.576941 L338.823529,903.631059 L903.529412,903.631059 L903.529412,790.576941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionSolid, _Component);

  var _super = _createSuper(IconDiscussionSolid);

  function IconDiscussionSolid() {
    _classCallCheck(this, IconDiscussionSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussion",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconDiscussionSolid.displayName = "IconDiscussionSolid";
  return IconDiscussionSolid;
}(Component);

IconDiscussionSolid.glyphName = 'discussion';
IconDiscussionSolid.variant = 'Solid';
IconDiscussionSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionSolid;
export { IconDiscussionSolid };